<script lang="ts" setup>
import { useImage } from '@/shared/composables/image'
import { IEventEdit } from '@/enitites/event'

defineProps<{
  eventData: IEventEdit
}>()

const { getImageById } = useImage()
</script>

<template>
  <div class="view-event">
    <p>Fill in the information to use the display mode in the event</p>

    <p v-if="!eventData.carpets?.length">
      <span class="view-event__bold-title"> No carpets added yet </span>
    </p>

    <div
      v-for="(carpet, index) in eventData.carpets || []"
      :key="index"
      class="view-event__tier"
    >
      <p class="view-event__title">{{ carpet.name }}</p>
    </div>

    <p
      v-if="eventData.scoreboardLogo"
      class="view-event__bold-title"
    >
      Scoreboard logo:
    </p>
    <p v-else>No scoreboard logo added yet</p>
    <v-img
      v-if="eventData.scoreboardLogo"
      :src="getImageById(eventData.scoreboardLogo, 800, 800)"
      class="view-event__scoreboard-logo d-flex align-center"
    />

    <p
      v-if="eventData.scoreboardBgImage"
      class="view-event__bold-title"
    >
      Scoreboard background:
    </p>
    <p v-else>No scoreboard background added yet</p>
    <v-img
      v-if="eventData.scoreboardBgImage"
      :src="getImageById(eventData.scoreboardBgImage, 800, 450)"
      class="view-event__scoreboard-bg d-flex align-center"
    />
  </div>
</template>

<style lang="scss" scoped>
.view-event {
  max-width: 400px;
  margin: 0 auto;

  &__title {
    margin: 16px 0;
    color: var(--color-dark-800);
    font-weight: var(--font-weight-semi-bold);
  }

  &__bold-title {
    font-weight: var(--font-weight-semi-bold);
  }

  &__tier {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  &__scoreboard-logo {
    max-width: 50%;
    height: auto;
    aspect-ratio: 1 / 1;
    margin: 0 auto 40px;
  }

  &__scoreboard-bg {
    height: auto;
    aspect-ratio: 16 / 9;
    margin: 0 auto 40px;
  }
}
</style>
